<textarea
  [formControl]="formControl"
  [formlyAttributes]="field"
  [attr.placeholder]="props.placeholder || ''"
  [attr.data-id]="field.dataId"
  [rows]="props.rows || 7"
  [class.disabled]="props.disabled"
  class="area"
></textarea>
